/** Business Growth – 6 cards */
export const recommendationWinter = [
  {
    id: 'increase-revenue',
    imageSrc: '/assets/img-7.jpg',
    imageAlt: 'Business growth and revenue increase analytics',
    label: 'Increase Revenue by Up to 25%',
    description:
      'Digital systems designed to convert more visitors into customers, improve booking performance, and increase overall business revenue. Our solutions are built to support measurable growth for businesses in Switzerland and Europe.',
    href: '/solutions/increase-revenue',
  },
  {
    id: 'reduce-costs',
    imageSrc: '/assets/img-8.jpg',
    imageAlt: 'Cost reduction and better business efficiency',
    label: 'Reduce OTA and Third-Party Dependence',
    description:
      'We help hotels and service businesses build stronger direct channels through better websites, booking-focused experiences, and hotel IT solutions in Switzerland that support more profitable customer relationships.',
    href: '/solutions/reduce-costs',
  },
  {
    id: 'save-time',
    imageSrc: '/assets/img-9.jpg',
    imageAlt: 'Automation and time saving digital systems',
    label: 'Reduce Manual Work by Up to 40%',
    description:
      'Our AI automation services and AI for business automation help companies simplify repetitive tasks, improve workflow efficiency, and save time across daily operations.',
    href: '/solutions/save-time',
  },
  {
    id: 'generate-qualified-leads',
    imageSrc: '/assets/img-10.jpeg',
    imageAlt: 'Lead generation and digital marketing growth',
    label: 'Generate More Qualified Leads',
    description:
      'High-converting websites, targeted digital strategy, and better user journeys help businesses attract the right audience and create stronger lead generation opportunities.',
    href: '/solutions/more-leads',
  },
  {
    id: 'improve-response-time',
    imageSrc: '/assets/img-19.png',
    imageAlt: 'Better customer experience and higher conversions',
    label: 'Improve Customer Response Time by Up to 60%',
    description:
      'Automation, AI chatbots, and smart communication systems help businesses respond faster, improve service quality, and create better customer experiences.',
    href: '/solutions/better-conversion',
  },
]


/** Services Focus – 6 cards */
export const recommendationSummer = [
  {
    id: 'ai-automation-case',
    imageSrc:
      '/assets/img-17.png',
    imageAlt: 'Website development and digital design workspace',
    label: 'Faster Responses Through AI Automation',
    description:
      'AI chatbots and workflow systems designed to improve customer response times for hospitality and service businesses. These AI automation services for businesses in Switzerland help teams save time and deliver faster support.',
    href: '/services/ai-automation-case',
    colSpan2: true,
  },
  {
    id: 'hotel-booking-case',
    imageSrc:
      '/assets/img-41.jpeg',
    imageAlt: 'Mobile app development for business growth',
    label: 'Boosting Direct Bookings and Hotel Profitability',
    description:
      'Booking-focused digital platforms and hotel booking system development in Switzerland that help hotels increase direct reservations, improve profitability, and reduce commission losses.',
    href: '/services/hotel-booking-case',
  },
  {
    id: 'lead-engine-case',
    imageSrc:
      '/assets/img-18.jpeg',
    imageAlt: 'Digital marketing strategy and analytics',
    label: 'Turning an Outdated Website into a Lead Engine',
    description:
      'A redesigned website with stronger user experience, SEO improvements, and modern conversion strategy helped transform a weak online presence into a reliable source of business inquiries.',
    href: '/services/lead-engine-case',
  },
]